import { Treatment } from '../models';

export const sortTreatments = <T extends Pick<Treatment, 'treatmentType' | 'periodId' | 'name'>>(
  treatments: T[],
): T[] =>
  [...treatments].sort(
    (a, b) =>
      a.treatmentType.localeCompare(b.treatmentType) ||
      a.periodId - b.periodId ||
      a.name.localeCompare(b.name),
  );
